module.exports = __webpack_public_path__ + "img/hands@2x.1cdeeb6.png";